<template>
    <el-form ref="form" :model="form" v-loading="isBusy" :rules="rules">
        <el-form-item prop="filemaker_id">
            <el-input
                placeholder="Filemaker ID"
                v-model="form.filemaker_id"
            >
            </el-input>
        </el-form-item>
        <el-row :gutter="20">
            <el-col :span="12">
                <el-form-item prop="first_name">
                    <el-input
                        placeholder="First Name"
                        v-model="form.first_name"
                    >
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item prop="last_name">
                    <el-input
                        placeholder="Last Name"
                        v-model="form.last_name"
                    >
                    </el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-form-item prop="phone_number">
            <el-input
                placeholder="Phone Number"
                v-model="form.phone_number"
            >
            </el-input>
        </el-form-item>
        <el-form-item prop="outgoing_number_id">
            <el-select
                class="w-100"
                v-model="form.outgoing_number_id"
                filterable
                clearable
                placeholder="Select Outgoing Number"
                popperClass="custom-popper">
                <el-option
                    v-for="item in outgoingNumbers"
                    :key="item.id"
                    :label="formatOutgoingNumber(item)"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="message">
            <el-input
                type="textarea"
                placeholder="Enter Message..."
                :autosize="{minRows:2, maxRows:6}"
                v-model="form.message"
                class="word-break-normal"
            >
            </el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="save">SEND MESSAGE</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
  import Form from "./form";
  import {modes} from "./types";

  export default {
    extends: Form,

    props: {
      //
    },

    data() {
      return {
        form: {
          filemaker_id: null,
          phone_number: null,
          first_name: null,
          last_name: null,
          outgoing_number_id: null,
          message: null,
        },
        rules: {
          filemaker_id: [{validator: this.fieldExternalValidator}],
          phone_number: [{validator: this.fieldExternalValidator}],
          first_name: [{validator: this.fieldExternalValidator}],
          last_name: [{validator: this.fieldExternalValidator}],
          outgoing_number_id: [{validator: this.fieldExternalValidator}],
          message: [{validator: this.fieldExternalValidator}],
        },
      };
    },

    methods: {
      /**
       * @return {undefined}
       */
      findContact() {
        this.$emit('change-mode', modes.find_send);
      },
    },
  }
</script>
